import { LogoutButton } from "~/components/layout/sidebar/LogoutButton";
import { SidebarLogo } from "~/components/layout/sidebar/SidebarLogo";
import { SidebarNavigation } from "~/components/layout/sidebar/SidebarNavigation";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
} from "~/components/ui/sidebar";
import { UserRole } from "~/types/user";

interface AppSidebarProps {
  userRole: UserRole;
}

export function AppSidebar({ userRole }: AppSidebarProps) {
  return (
    <Sidebar>
      <SidebarHeader>
        <SidebarLogo userRole={userRole} />
      </SidebarHeader>
      <SidebarContent>
        <SidebarNavigation userRole={userRole} />
      </SidebarContent>
      <SidebarFooter>
        <div className="p-4">
          <LogoutButton />
        </div>
      </SidebarFooter>
    </Sidebar>
  );
}
